import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";

const BarCharTwo = (props) => {


  const symbol = props.symbol || '';

  const getOptions = () => ({
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      orient: 'horizontal',
      left: 'center',
      top: 'bottom'
    },

    grid: {
      top: '15%', // Espacio superior
      left: '10%', // Espacio izquierdo
      right: '10%', // Espacio derecho
      bottom: '30%', // Aumenta este valor para dar más espacio en la parte inferior
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: props.categories,
      axisLabel: {
        rotate: 30,
        interval: 0,
        textStyle: {
          fontSize: 12,
          color: '#333',
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: props.nameBar,
        position: 'left'
      },
      {
        type: 'value',
        name: props.nameLine,
        position: 'right'
      }
    ],

    series: [
      {
        name: props.nameBar,
        type: 'bar',
        data: props.applications,
        yAxisIndex: 0,
        barGap: '10%',
        itemStyle: {
          color: props.barColor || '#5470C6'
        },
        label: {
          show: true,
          position: 'insideBottom',
          formatter: (params) => {
            const value = Number(params.value);

            if (!Number.isFinite(value)) return '0' + symbol;

            return new Intl.NumberFormat('es-CO', {
              minimumFractionDigits: props.decimals ?? 0,
              maximumFractionDigits: props.decimals ?? 0,
            }).format(value) + symbol;
          }
        }
      },

      ...(props.applications2 ? [{
        name: props.nameBar2,
        type: 'bar',
        data: props.applications2,
        yAxisIndex: 1,
        itemStyle: {
          color: props.barColor2 || '#18B8B3'
        },
        label: {
          show: true,
          position: 'insideBottom',
          formatter: (params) => {
            const value = Number(params.value);

            if (!Number.isFinite(value)) return '0';

            return new Intl.NumberFormat('es-CO', {
              minimumFractionDigits: props.decimals2 ?? 2,
              maximumFractionDigits: props.decimals2 ?? 2,
            }).format(value);
          }
        }
      }] : [])
    ]

  });

  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
};

export default BarCharTwo;
